import jsonp from 'jsonp';

export default {
    serverName: 'https://iptv.kartina.tv/api/json/',

    // Videoteka Kartina.TV
    getVODList(category = '', callback) {
        jsonp(this.serverName + 'vod_index?category=' + category, null, callback);
    },
    searchVOD(type, {genre = '', query = '', category = '', page = '', numbs = ''}, callback) {
        jsonp(this.serverName + `vod_list?type=${type}&genre=${genre}&query=${query}&category=${category}&page=${page}&numbs=${numbs}`, null, callback);
    },
    getVODItem(id, protectionCode = '', callback) {
        jsonp(this.serverName + `vod_info?id=${id}&protect_code=${protectionCode}`, null, callback);
    },
    getVODMovieSelection(id, callback) {
        jsonp(this.serverName + `vod_selection?id=${id}`, null, callback);
    },
    getVODStreamUrl(fileId, protectionCode = '', callback) {
        jsonp(this.serverName + `vod_geturl?fileid=${fileId}&protect_code=${protectionCode}`, null, callback);
    },
    getVODGenres(callback) {
        jsonp(this.serverName + 'vod_genres', null, callback);
    },
    getVODSettings(protectionCode, callback) {
        jsonp(this.serverName + 'vod_manage?cmd=get_user_rates&protect_code=' + protectionCode, null, callback);
    },
    setVODSettings(protectionCode, {blood = '', violence = '', obsence = '', porn = '', horror = ''}, callback) {
        jsonp(this.serverName + `vod_manage?cmd=set_user_rates&protect_code=${protectionCode}&blood=${blood}&violence=${violence}&obsence=${obsence}&porn=${porn}&horror=${horror}`, null, callback);
    },
    getVODFavorites(callback) {
        jsonp(this.serverName + 'vod_favlist', null, callback);
    },
    addToVODFavorites(id, callback) {
        jsonp(this.serverName + 'vod_favadd?id=' + id, null, callback); 
    },
    removeFromVODFavorites(id, callback) {
        jsonp(this.serverName + 'vod_favsub?id=' + id, null, callback);
    },
}


// WEBPACK FOOTER //
// ./src/libs/videoteka.js